import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getWeeklyUploaded as getWeeklyUploadedApi,
  getWeeklyUploadedByChannel as getWeeklyUploadedByChannelApi,
  getWeeklyNewSupliers as getWeeklyNewSupliersApi,
  getWeeklyTotalOrderAmount as getWeeklyTotalOrderAmountApi,
  getUsersStatsByRange as getUserStatsApi,
  getWeeklyTotalSupplierCancelledOrders as getWeeklyTotalSupplierCancelledOrdersApi,
  getWeeklyTotalCustomerCancelledOrders as getWeeklyTotalCustomerCancelledOrdersApi,
  getSubscriptionStats as getSubscriptionStatsApi,
  getWeeklyTotalPurchases as getWeeklyTotalPurchasesApi,
  getWeeklyRefunds as getWeeklyRefundsApi,
  getTopMembersPurchases as getTopMembersPurchasesApi,
  getTopProductMargins as getTopProductMarginsApi,
  getTopSellers as getTopSellersApi,
  getTopSellerSuppliers as getTopSellerSuppliersApi,
  getWeeklyGeneralSupplierOrderCounts as WeeklyGeneralSupplierOrderCountsApi,
  getGeneralSupplierOrderCounts as GeneralSupplierOrderCountsApi,
  getWeeklyGeneralCustomerOrderCounts as WeeklyGeneralCustomerOrderCountsApi,
  getInventoryHistory as getInventoryHistoryApi,
  getWeeklyProfitableProducts as getWeeklyProfitableProductsApi,
  getMonthlyUploaded as getMonthlyUploadedApi,
  getMonthlyUploadedByChannel as getMonthlyUploadedByChannelApi,
  getMonthlyNewSuppliers as getMonthlyNewSuppliersApi,
  getMonthlyGeneralSupplierOrderCounts as getMonthlyGeneralSupplierOrderCountsApi,
  getMonthlyGeneralCustomerOrderCounts as getMonthlyGeneralCustomerOrderCountsApi,
  getMonthlyRefunds as getMonthlyRefundsApi,
  getMonthlyProfitableProducts as getMonthlyProfitableProductsApi,
} from "../../apiCalls/caller";

export const getWeeklyUploaded = createAsyncThunk(
  "dashboard/getWeeklyUploaded",
  async (data) => {
    try {
      const response = await getWeeklyUploadedApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const getWeeklyUploadedByChannel = createAsyncThunk(
  "dashboard/getWeeklyUploadedByChannel",
  async (data) => {
    try {
      const response = await getWeeklyUploadedByChannelApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getWeeklyNewSupliers = createAsyncThunk(
  "dashboard/getWeeklyNewSupliers",
  async (data) => {
    try {
      const response = await getWeeklyNewSupliersApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const getWeeklyTotalOrderAmount = createAsyncThunk(
  "dashboard/getWeeklyTotalOrderAmount",
  async (data) => {
    try {
      const response = await getWeeklyTotalOrderAmountApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getWeeklyTotalSupplierCancelledOrders = createAsyncThunk(
  "dashboard/getWeeklyTotalSupplierCancelledOrders",
  async (data) => {
    try {
      const response = await getWeeklyTotalSupplierCancelledOrdersApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getWeeklyTotalCustomerCancelledOrders = createAsyncThunk(
  "dashboard/getWeeklyTotalCustomerCancelledOrders",
  async (data) => {
    try {
      const response = await getWeeklyTotalCustomerCancelledOrdersApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getUserStats = createAsyncThunk(
  "dashboard/getUserStats",
  async (data) => {
    try {
      const response = await getUserStatsApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getSubscriptionStats = createAsyncThunk(
  "dashboard/getSubscriptionStats",
  async (data) => {
    try {
      const response = await getSubscriptionStatsApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getWeeklyTotalPurchases = createAsyncThunk(
  "dashboard/getWeeklyTotalPurchases",
  async (data) => {
    try {
      const response = await getWeeklyTotalPurchasesApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getWeeklyRefunds = createAsyncThunk(
  "dashboard/getWeeklyRefunds",
  async (data) => {
    try {
      const response = await getWeeklyRefundsApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const getTopMembersPurchases = createAsyncThunk(
  "dashboard/getTopMembersPurchases",
  async (data) => {
    try {
      const response = await getTopMembersPurchasesApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const getTopProductMargins = createAsyncThunk(
  "dashboard/getTopProductMargins",
  async (data) => {
    try {
      const response = await getTopProductMarginsApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const getTopSellers = createAsyncThunk(
  "dashboard/getTopSellers",
  async (data) => {
    try {
      const response = await getTopSellersApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getTopSellerSuppliers = createAsyncThunk(
  "dashboard/getTopSellerSuppliers",
  async (data) => {
    try {
      const response = await getTopSellerSuppliersApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getWeeklyGeneralSupplierOrderCounts = createAsyncThunk(
  "dashboard/WeeklyGeneralSupplierOrderCounts",
  async (data) => {
    try {
      const response = await WeeklyGeneralSupplierOrderCountsApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const getGeneralSupplierOrderCounts = createAsyncThunk(
  "dashboard/GeneralSupplierOrderCounts",
  async (data) => {
    try {
      const response = await GeneralSupplierOrderCountsApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const getWeeklyGeneralCustomerOrderCounts = createAsyncThunk(
  "dashboard/WeeklyGeneralCustomerOrderCounts",
  async (data) => {
    try {
      const response = await WeeklyGeneralCustomerOrderCountsApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const getInventoryHistory = createAsyncThunk(
  "dashboard/getInventoryHistory",
  async (data) => {
    try {
      const response = await getInventoryHistoryApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getWeeklyProfitableProducts = createAsyncThunk(
  "dashboard/getWeeklyProfitableProducts",
  async (data) => {
    try {
      const response = await getWeeklyProfitableProductsApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Monthly dashboard thunks (used when period > 58 days)
export const getMonthlyUploaded = createAsyncThunk(
  "dashboard/getMonthlyUploaded",
  async (data) => {
    try {
      const response = await getMonthlyUploadedApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const getMonthlyUploadedByChannel = createAsyncThunk(
  "dashboard/getMonthlyUploadedByChannel",
  async (data) => {
    try {
      const response = await getMonthlyUploadedByChannelApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const getMonthlyNewSuppliers = createAsyncThunk(
  "dashboard/getMonthlyNewSuppliers",
  async (data) => {
    try {
      const response = await getMonthlyNewSuppliersApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const getMonthlyGeneralSupplierOrderCounts = createAsyncThunk(
  "dashboard/getMonthlyGeneralSupplierOrderCounts",
  async (data) => {
    try {
      const response = await getMonthlyGeneralSupplierOrderCountsApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const getMonthlyGeneralCustomerOrderCounts = createAsyncThunk(
  "dashboard/getMonthlyGeneralCustomerOrderCounts",
  async (data) => {
    try {
      const response = await getMonthlyGeneralCustomerOrderCountsApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const getMonthlyRefunds = createAsyncThunk(
  "dashboard/getMonthlyRefunds",
  async (data) => {
    try {
      const response = await getMonthlyRefundsApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const getMonthlyProfitableProducts = createAsyncThunk(
  "dashboard/getMonthlyProfitableProducts",
  async (data) => {
    try {
      const response = await getMonthlyProfitableProductsApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
